import { make } from 'vuex-pathify';
import { every, keyBy, keys, shuffle, sortBy } from 'lodash';

const steps = keyBy(
    [
        {
            id: 1,
            text: 'Check the expiration date on the wrapper'
        },
        {
            id: 2,
            text: 'Open the package without tearing the condom – don’t use your teeth!'
        },
        {
            id: 3,
            text: 'Squeeze a few drops of water-based lube into the tip of the condom'
        },
        {
            id: 4,
            text: 'Hold the condom by the last ½ inch at the tip, squeeze out any air'
        },
        {
            id: 5,
            text: 'Start to put the condom on when the dick is hard and before the dick touches the partner’s genitalia, mouth, or ass'
        },
        {
            id: 6,
            text: 'While still pinching the tip, unroll the condom down the shaft of the dick'
        },
        {
            id: 7,
            text: 'Check during sex to make sure the condom isn’t slipping off'
        },
        {
            id: 8,
            text: 'After cumming, pull out while holding the condom by its rim (at the base of the dick, near the balls)'
        },
        {
            id: 9,
            text: 'Throw the condom away (not in a toilet, it can clog the pipes!)'
        },
        {
            id: 10,
            text: 'Never re-use a condom. Use a new one every time you have sex, and repeat these steps.'
        }
    ],
    'id'
);
const stepsOrder = sortBy(keys(steps), k => parseInt(k));
const shuffledStepsOrder = shuffle(keys(steps)); // shuffle once, on module creation

const state = {
    title: 'Condom Use Steps',
    complete: false,
    sticker: {
        text: 'Eggplant emoji',
        earned: false,
        image: require('@/assets/stickers/stickers_0005_eggplant.png')
    },
    bonusSticker: false,
    trophy: false,
    steps,
    stepsOrder,
    shuffledStepsOrder
};
const getters = {
    ...make.getters(state),
    isShuffledStepsOrderSorted: state => {
        return every(state.shuffledStepsOrder, (value, index) => {
            return parseInt(value) === index + 1;
        });
    }
};
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
